import react from "../../img/react.svg";
import html from "../../img/html.svg";
import css from "../../img/css.svg";
import javascript from "../../img/javascript.svg";
import redux from "../../img/redux.svg";
import typescript from "../../img/typescript.png";
import chakra from "../../img/chakra.png";
import materialui from "../../img/materialui.svg";
import nodejs from "../../img/nodejs.svg";
import express from "../../img/express.svg";
import mongodb from "../../img/mongodb.svg";
import git from "../../img/git.svg";
import npm from "../../img/npm.svg";
import database from "../../img/database.png";
import cypress from "../../img/cypress.webp";
import postman from "../../img/postman.png";

export const skill = [
  {
    img: html,
    title: "HTML",
  },
  {
    img: css,
    title: "CSS",
  },
  {
    img: javascript,
    title: "Javascript",
  },
  {
    img: react,
    title: "React",
  },
  {
    img: redux,
    title: "Redux",
  },
  {
    img: typescript,
    title: "Typescript",
  },
  {
    img: chakra,
    title: "Chakra",
  },
  {
    img: materialui,
    title: "Materialui",
  },
  {
    img: "https://i.imgur.com/8xILRKD.png",
    title: "Tailwind CSS",
  },
  {
    img: nodejs,
    title: "NodeJs",
  },
  {
    img: express,
    title: "Express",
  },
  {
    img: mongodb,
    title: "MongoDb",
  },
  {
    img: git,
    title: "Git",
  },
  {
    img: npm,
    title: "npm",
  },
  {
    img: postman,
    title: "Postman",
  },
];
